import React, { forwardRef, memo } from "react";
import { Message } from "./Message";
import { TypingIndicator } from "./TypingIndicator";
import type { ChatMessage } from "@/types/conversationTypes";

type MessagesListProps = {
  messages: ChatMessage[];
  isTyping: boolean;
  isConversationClosed: boolean;
  onOptionSelect: (id: string, title: string) => void;
};

/**
 * Message list with native scroll.
 * ForwardRef to control the scroll from ChatContainer.
 */
const MessagesListBase = forwardRef<HTMLDivElement, MessagesListProps>(
  ({ messages, isTyping, onOptionSelect, isConversationClosed }, ref) => {
    return (
      <div ref={ref} className="h-full overflow-y-auto px-4 py-2">
        <div className="space-y-4 pb-4">
          {messages.map((m) => (
            <Message
              key={m.id}
              id={m.id}
              content={m.content}
              isUser={m.isUser}
              timestamp={m.timestamp?.toISOString()}
              images={m.images}
              options={m.options}
              onOptionSelect={onOptionSelect}
              isConversationClosed={isConversationClosed}
            />
          ))}
          {isTyping && <TypingIndicator />}
        </div>
      </div>
    );
  }
);

export const MessagesList = memo(MessagesListBase);
